import {
  GET_AWS_ALL_RESOURCE_ALERTS,
  GET_AWS_ALL_RESOURCE_ALERTS_FAIL,
  GET_AWS_ALL_RESOURCE_ALERTS_SUCCESS,
  GET_CLOUD_RESOURCES,
  GET_CLOUD_RESOURCES_FAIL,
  GET_CLOUD_RESOURCES_SUCCESS,
  POST_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  POST_UPDATE_RESOURCE_ENVIRONMENT,
  POST_UPDATE_RESOURCE_ENVIRONMENT_SUCCESS,
  POST_UPDATE_RESOURCE_ENVIRONMENT_FAIL,
  GET_AWS_ALL_RESOURCE_ALERTS_PAGE,
  GET_AWS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_AWS_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_ALL_ORG_AWS_RESOURCE_TYPES,
  GET_ALL_ORG_AWS_RESOURCE_TYPES_SUCCESS,
  GET_ALL_ORG_AWS_RESOURCE_TYPES_FAIL,
  POST_RESOURCE_SERVICE_MAPPING,
  POST_RESOURCE_SERVICE_MAPPING_SUCCESS,
  POST_RESOURCE_SERVICE_MAPPING_FAIL,
  GET_AWS_ALL_RESOURCE_COUNT,
  GET_AWS_ALL_RESOURCE_COUNT_FAIL,
  GET_AWS_ALL_RESOURCE_COUNT_SUCCESS,
  GET_AWS_APPSYNC_DATA_SOURCES_ALERTS,
  GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_FAIL,
  GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_SUCCESS,
  GET_AWS_APPSYNC_DATA_SOURCES_COUNT,
  GET_AWS_APPSYNC_DATA_SOURCES_COUNT_FAIL,
  GET_AWS_APPSYNC_DATA_SOURCES_COUNT_SUCCESS,
    GET_AWS_APPSYNC_RESOLVERS_COUNT,
    GET_AWS_APPSYNC_RESOLVERS_COUNT_FAIL,
    GET_AWS_APPSYNC_RESOLVERS_COUNT_SUCCESS,
    GET_AWS_APPSYNC_RESOLVERS_ALERTS,
    GET_AWS_APPSYNC_RESOLVERS_ALERTS_FAIL,
    GET_AWS_APPSYNC_RESOLVERS_ALERTS_SUCCESS,
    GET_USER_RESCAN_STATUS,
    GET_USER_RESCAN_STATUS_FAIL,
    GET_USER_RESCAN_STATUS_SUCCESS,

} from "./actionTypes";

export const getAWSAllResourceAlerts = () => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS,
})

export const getAWSAllResourceAlertsSuccess = aws_all_resource_alerts => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS_SUCCESS,
  payload: aws_all_resource_alerts,
})

export const getAWSAllResourceAlertsFail = error => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS_FAIL,
  payload: error,
})

export const getAWSAllResourceAlertsPage = (page_filters) => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS_PAGE,
  payload: {page_filters}
})

export const getAWSAllResourceAlertsPageSuccess = aws_all_resource_alerts => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  payload: aws_all_resource_alerts,
})

export const getAWSAllResourceAlertsPageFail = error => ({
  type: GET_AWS_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  payload: error,
})

export const getAWSResourceCount = (page_filters) => ({
  type: GET_AWS_ALL_RESOURCE_COUNT,
  payload: {page_filters}
})

export const getAWSResourceCountSuccess = aws_all_resource_count => ({
  type: GET_AWS_ALL_RESOURCE_COUNT_SUCCESS,
  payload: aws_all_resource_count,
})

export const getAWSResourceCountFail = error => ({
  type: GET_AWS_ALL_RESOURCE_COUNT_FAIL,
  payload: error,
})

export const getAllOrgAWSResourceTypes = () => ({
  type: GET_ALL_ORG_AWS_RESOURCE_TYPES
})

export const getAllOrgAWSResourceTypesSuccess = orgAWSResourceTypes => ({
  type: GET_ALL_ORG_AWS_RESOURCE_TYPES_SUCCESS,
  payload: orgAWSResourceTypes,
})

export const getAllOrgAWSResourceTypesFail = error => ({
  type: GET_ALL_ORG_AWS_RESOURCE_TYPES_FAIL,
  payload: error,
})

export const getCloudResources = (data) => {
  return {
    type: GET_CLOUD_RESOURCES,
    payload: data
  }
}

export const getCloudResourcesSuccess = cloudResources => ({
  type: GET_CLOUD_RESOURCES_SUCCESS,
  payload: cloudResources,
})

export const getCloudResourcesFail = error => ({
  type: GET_CLOUD_RESOURCES_FAIL,
  payload: error,
})

export const postResourceOpsGenieTeamMapping = resource_team_mapping => {
  return {
    type: POST_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { resource_team_mapping }
  }
}

export const postResourceOpsGenieTeamMappingSuccess = cloudResources => ({
  type: POST_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  payload: cloudResources,
})

export const postResourceOpsGenieTeamMappingFail = error => ({
  type: POST_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  payload: error,
})

export const postResourcePagerdutyServiceMapping = resource_service_mapping => {
  return {
    type: POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: { resource_service_mapping }
  }
}

export const postResourcePagerdutyServiceMappingSuccess = cloudResources => ({
  type: POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  payload: cloudResources,
})

export const postResourcePagerdutyServiceMappingFail = error => ({
  type: POST_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  payload: error,
})

export const postResourceServiceMapping = resource_service_mapping => {
  return {
    type: POST_RESOURCE_SERVICE_MAPPING,
    payload: { resource_service_mapping }
  }
}

export const postResourceServiceMappingSuccess = cloudResources => ({
  type: POST_RESOURCE_SERVICE_MAPPING_SUCCESS,
  payload: cloudResources,
})

export const postResourceServiceMappingFail = error => ({
  type: POST_RESOURCE_SERVICE_MAPPING_FAIL,
  payload: error,
})

export const postUpdateResourceEnvironment = resource_environment => {
  return {
    type: POST_UPDATE_RESOURCE_ENVIRONMENT,
    payload: { resource_environment }
  }
}

export const postUpdateResourceEnvironmentSuccess = cloudResources => ({
  type: POST_UPDATE_RESOURCE_ENVIRONMENT_SUCCESS,
  payload: cloudResources,
})

export const postUpdateResourceEnvironmentFail = error => ({
  type: POST_UPDATE_RESOURCE_ENVIRONMENT_FAIL,
  payload: error,
})


export const getAWSAppSyncDataSourcesAlertsPage = (page_filters) => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_ALERTS,
  payload: {page_filters}
})

export const getAWSAppSyncDataSourcesAlertsPageSuccess = aws_all_resource_alerts => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_SUCCESS,
  payload: aws_all_resource_alerts,
})

export const getAWSAppSyncDataSourcesAlertsPageFail = error => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_ALERTS_FAIL,
  payload: error,
})

export const getAWSAppsyncDataSourceCount = (page_filters) => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_COUNT,
  payload: {page_filters}
})

export const getAWSAppsyncDataSourceCountSuccess = aws_all_resource_count => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_COUNT_SUCCESS,
  payload: aws_all_resource_count,
})

export const getAWSAppsyncDataSourceCountFail = error => ({
  type: GET_AWS_APPSYNC_DATA_SOURCES_COUNT_FAIL,
  payload: error,
})

export const getAWSAppSyncResolversAlertsPage = (page_filters) => ({
  type: GET_AWS_APPSYNC_RESOLVERS_ALERTS,
  payload: {page_filters}
})

export const getAWSAppSyncResolversAlertsPageSuccess = aws_all_resource_alerts => ({
  type: GET_AWS_APPSYNC_RESOLVERS_ALERTS_SUCCESS,
  payload: aws_all_resource_alerts,
})

export const getAWSAppSyncResolversAlertsPageFail = error => ({
  type: GET_AWS_APPSYNC_RESOLVERS_ALERTS_FAIL,
  payload: error,
})

export const getAWSAppsyncResolversCount = (page_filters) => ({
  type: GET_AWS_APPSYNC_RESOLVERS_COUNT,
  payload: {page_filters}
})

export const getAWSAppsyncResolversCountSuccess = aws_all_resource_count => ({
  type: GET_AWS_APPSYNC_RESOLVERS_COUNT_SUCCESS,
  payload: aws_all_resource_count,
})

export const getAWSAppsyncResolversCountFail = error => ({
  type: GET_AWS_APPSYNC_RESOLVERS_COUNT_FAIL,
  payload: error,
})



export const getAwsRefreshScanStatus = () => ({
  type: GET_USER_RESCAN_STATUS,
})

export const getAwsRefreshScanStatusSuccess = aws_refresh_status => ({
  type: GET_USER_RESCAN_STATUS_SUCCESS,
  payload: aws_refresh_status,
})

export const getAwsRefreshScanStatusFail = error => ({
  type: GET_USER_RESCAN_STATUS_FAIL,
  payload: error,
})


